import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { User, ItemUrls, Training } from '../app.urls';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  // variable declaration
  private errorResponseSubject: BehaviorSubject<any>;
  errorResponseSubjectObservable: Observable<any>;

  private newUser = new BehaviorSubject<any>('');
  public getNewData = this.newUser.asObservable();

  constructor(private http: HttpClient) {
    this.errorResponseSubject = new BehaviorSubject<any>('');
    this.errorResponseSubjectObservable =
      this.errorResponseSubject.asObservable();
  }

  newUserList(user: any) {
    this.newUser.next(user);
  }

  getusers(): Observable<any> | null {
    const collectionuuId = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
    return this.http.get<any>(User.User + collectionuuId)
  }


  // This service is  used on Users landing page
  getusersLanding(): Observable<any> | null {
    return this.http.get<any>(User.usersLanding)
  }

  getUsersByID(useruuid: number): Observable<any> | null {
    return this.http.get<any>(User.UsersByID + useruuid)
  }

  getUsersFilter(options: any): Observable<any> | null {
    // const fetchItemapiUrl = environment.apiUrl + 'items?collectionId=' + filterData.collectionId + '&itemBankName=' + item.itemName + '&itemDescription=' + item.itemDescription + '&itemStatus' + item.itemStaus;
    // const fetchTestApiUrl = environment.apiUrl
    //   + 'tests?collectionId=' + filterData.collectionId
    //   + '&testName=' + filterData.testName
    //   + '&testDescription=' + filterData.testDescription
    //   + '&tagdescription=' + filterData.tagdescription
    //   + '&testStatus=' + filterData.testStatus;
    // '&itemBankName=' + item.itemName + '&itemDescription=' + item.itemDescription + '&itemStatus=' + item.itemStatus + '&tag=' + item.tag;

    const collectionuuId = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));

    // const fetchUsersApiUrl = environment.apiUrl + 'users/' + clientId + '?userfirstName=' + options.userfirstName + '&userlastName=' + options.userlastName + '&userActiveStatus=' + options.userActiveStatus;

    return this.http.get<any>(User.User + collectionuuId + '?' + options)
  }

  // THis service used on users landing page as user filter function
  UsersFilter(options: any): Observable<any> | null {
    // const fetchItemapiUrl = environment.apiUrl + 'items?collectionId=' + filterData.collectionId + '&itemBankName=' + item.itemName + '&itemDescription=' + item.itemDescription + '&itemStatus' + item.itemStaus;
    // const fetchTestApiUrl = environment.apiUrl
    //   + 'tests?collectionId=' + filterData.collectionId
    //   + '&testName=' + filterData.testName
    //   + '&testDescription=' + filterData.testDescription
    //   + '&tagdescription=' + filterData.tagdescription
    //   + '&testStatus=' + filterData.testStatus;
    // '&itemBankName=' + item.itemName + '&itemDescription=' + item.itemDescription + '&itemStatus=' + item.itemStatus + '&tag=' + item.tag;
      // const fetchUsersApiUrl = environment.apiUrl + 'users/' + clientId + '?userfirstName=' + options.userfirstName + '&userlastName=' + options.userlastName + '&userActiveStatus=' + options.userActiveStatus;
      // const fetchUsersApiUrl = environment.apiUrl + 'users/' + clientId + '/' + collectionId + '?' + options;

      return this.http.get<any>(User.usersLanding + '?' + options)
  }

  createNewUser(dataToApi: any) {
    const currentUserFromStorage = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );
    const clientuuId = currentUserFromStorage.clientuuId;

    dataToApi.clientuuId = clientuuId;
    return this.http.post<any>(User.CreateNewUser, JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  editUser(dataToApi: any, useruuid: number) {
    return this.http.put<any>(User.usersLanding + useruuid, JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  getStatusList() {
    return this.http.get<any>(ItemUrls.statusList)
  }

  videoTutorial(assetGroup) {
    return this.http.get<any>(Training.tutorial + assetGroup);
  }
}
